import { createContext, useContext, useMemo } from 'react';
import { Toaster, toast as sonnerToast } from 'sonner';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const toast = useMemo(() => ({
    // opts are forwarded to sonner — pass { id } to update an existing
    // toast in place (e.g. turn a loading toast into success/error).
    success: (msg, opts) => sonnerToast.success(msg, opts),
    error: (msg, opts) => sonnerToast.error(msg, { duration: 6000, ...opts }),
    info: (msg, opts) => sonnerToast.info(msg, opts),
    warning: (msg, opts) => sonnerToast.warning(msg, opts),
    // Spinner toast for in-progress work; returns an id. Resolve it with
    // toast.success(msg, { id }) / toast.error(msg, { id }).
    loading: (msg, opts) => sonnerToast.loading(msg, opts),
    dismiss: (id) => sonnerToast.dismiss(id),
  }), []);

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'text-sm',
          style: {
            fontFamily: 'inherit',
          },
        }}
        richColors
        closeButton
      />
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
